import {Box, Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useRouter} from 'next/router';
import {FC, useState} from 'react';
import {TranslationKeys} from 'translations';
import {SchedulesItem} from 'types';

const daysList = {
  en: {
    mo: 'Mo',
    tu: 'Tu',
    we: 'We',
    th: 'Th',
    fr: 'Fr',
    sa: 'Sa',
    su: 'Su',
  },
  ru: {
    mo: 'По',
    tu: 'Вт',
    we: 'Ср',
    th: 'Чт',
    fr: 'Пт',
    sa: 'Сб',
    su: 'Вс',
  },
  ro: {
    mo: 'Lu',
    tu: 'Ma',
    we: 'Me',
    th: 'Jo',
    fr: 'Vi',
    sa: 'Sa',
    su: 'Du',
  },
};

interface Props {
  schedules: SchedulesItem[];
  t: (term: TranslationKeys) => string;
}

export const SelectDay: FC<Props> = ({t, schedules}) => {
  const currentDay = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const {locale} = useRouter();
  const currentLang = locale as 'ru' | 'ro' | 'en';
  const [todayIndex, setTodayIndex] = useState(currentDay);

  const scheduleTitle = schedules[todayIndex].round_the_clock
    ? t('NON_STOP')
    : schedules[todayIndex].fromHour
    ? `${schedules[todayIndex].fromHour} - ${schedules[todayIndex].toHour}`
    : t('notWorking');

  const days = Object.values(daysList[currentLang]);

  return (
    <Box>
      <Flex justifyContent="center">
        {days.map((item, index) => {
          const activeDay = todayIndex === index;

          return (
            <Box as="button" key={item} onClick={() => setTodayIndex(index)}>
              <Flex
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                border="1px solid"
                borderColor={colors.black}
                bg={`${activeDay ? colors.lightGray : colors.white}`}
                color={`${activeDay ? colors.black : colors.textGray}`}
                w={['35px', '75px']}
                h={['35px', '75px']}
                fontWeight={600}
                mx={['5px', '7px']}
              >
                {item}
              </Flex>
            </Box>
          );
        })}
      </Flex>
      <Text mt="20px" textAlign="center" fontSize="18px" fontWeight="600" color={colors.black}>
        {scheduleTitle}
      </Text>
    </Box>
  );
};
